import axios from "axios";

const accessToken = localStorage.getItem("@user");
export const fetchBookmarks = async () => {
  try {
    const response = await axios.get(
      "https://htprdapi.hightable.ai/bookmark/list?limit=30",
      {
        headers: {
          accept: "application/json, text/plain, */*",
          authorization: `Bearer ${accessToken}`, // Keep the authorization header
        },
      }
    );

    // Return the response data
    return response.data.items;
  } catch (error) {
    console.error("Error fetching bookmarks:", error);
    throw error; // Rethrow the error for further handling
  }
};

const BASE_URL = "https://htprdapi.hightable.ai/bookmark/create";

export const addBookmark = async (tableId) => {
  try {
    const response = await axios.post(
      `${BASE_URL}?access_token=${accessToken}`,
      { table_id: tableId },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding bookmark:", error);
    throw error;
  }
};
